import { io } from 'socket.io-client';

import { ENV } from '../app/env';

// Вебсокеты обслуживает отдельный ws-proxy, а не основной бэкенд.
// Без VITE_WS_URL падаем на API_BACKEND_URL — как было раньше.
const socket = io(ENV.WS_URL || ENV.API_BACKEND_URL, {
  autoConnect: false,
  reconnectionDelay: 3000,
});

export { socket };
